// @owners { team: patients-team }
import { TypescriptUtils } from '~shared/TypescriptUtils';
import { type CreateManualInsurancePayload } from '~shared/features/insurances/types';

/**
 * Form inputs often normalize blanks to empty strings. The API expects omitted / undefined
 * fields instead of `''` (e.g. optional nickname).
 * Mutates and returns the same object.
 */
export function removeEmptyInsuranceValues(insurance: CreateManualInsurancePayload): CreateManualInsurancePayload {
  TypescriptUtils.objectKeys(insurance).forEach((key) => {
    const value = insurance[key];
    if (value === '') {
      insurance[key] = undefined;
    }
  });

  return insurance;
}
